import React, { useState, useEffect, useRef  } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';

const ProductMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  const [rangeModalVisible, setRangeModalVisible] = useState(false); 
  const [reorderModalVisible, setReorderModalVisible] = useState(false); 
  const [modalvalue, setModalvalue] = useState('Update'); 
  
  const [codeList, setCodeList] = useState([]);
  const [catlist, setCatlist] = useState([]);
  const [prdlist, setPrdlist] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [selectedCatId, setSelectedCatId] = useState('');
  const [allProducts, setAllProducts] = useState([]);
  const [priorityProducts, setPriorityProducts] = useState([]);
  const [uploadImage, setUploadImage] = useState('');
  const [imagePreview, setImagePreview] = useState(null);

  const [unitlist, setUnitlist] = useState([]);
  const [selectedunit, setSelectedUnit] = useState('');

  const [prdNameFilter, setPrdNameFilter] = useState('');
  const [prdEnameFilter, setPrdEnameFilter] = useState('');
  const [catEnameFilter, setCatEnameFilter] = useState('');
  const [prdStatusFilter, setPrdStatusFilter] = useState('');
  const [stockFilter, setStockFilter] = useState('');


  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      setImagePreview('');
      setUploadImage('');
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible || rangeModalVisible || reorderModalVisible) {
            if(rangeModalVisible) {
              setRangeModalVisible(false);
            } else {
              setModalVisible(false);
              setAddModalVisible(false);
              setReorderModalVisible(false);
            }            
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert" && !addmodalVisible) {
          setAddModalVisible(true);
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible, rangeModalVisible, reorderModalVisible]); 

    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          const formData = new FormData();
          formData.append("type", "list");
          formData.append("store", store);
          formData.append("catlist", '');

          try {
            const response = await fetch(`${host_url}/category_mlist`, {
              method: 'POST',
              body: formData,
            });
            
            const data = await response.json();
            setCatlist(data);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url]); // Categoty Fetch 

    useEffect(() => { 
      if(selectedProduct.prd_id){
        const fetchPrangeList = async () => { 
            if(selectedProduct) {
              try {
                const response = await fetch(`${host_url}/prange_list`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json', 
                  },
                  body: JSON.stringify({
                    type: 'list',
                    store: store,
                    prdId: selectedProduct.prd_id,  
                  }),
                });

                const data = await response.json();
                setUnitlist(data);
              } catch (error) {
                console.error('Error fetching categories:', error);
              }
            }
        }; 
        fetchPrangeList(); 
      }  
    }, [selectedProduct.prd_id]); // Range Fetch 

    useEffect(() => { 
       if (!modalVisible) {
        setSelectedProduct({});
       }

       

      const fetchCatagoryList = async () => { 
          const formData = new FormData();
          formData.append("type", "list");
          formData.append("store", store);
          formData.append("prdlist", '');

          try {
            const response = await fetch(`${host_url}/product_mlist`, {
              method: 'POST',
              body: formData,
            });
            
            const data = await response.json();
            setPrdlist(data);

            if(!catEnameFilter){
                setAllProducts(data.filter(p => Number(p.prd_priority) === 0 && p.prd_status === "Y"));
                setPriorityProducts(data.filter(p => Number(p.prd_priority) === 1 &&  p.prd_status === "Y"));
            } else {
                setAllProducts(prdlist.filter(p => Number(p.prd_priority) === 0 && Number(p.pcat_id) === Number(catEnameFilter) && p.prd_status === "Y"));
                setPriorityProducts(prdlist.filter(p => Number(p.prd_priority) === 1 && Number(p.pcat_id) === Number(catEnameFilter) && p.prd_status === "Y"));
            }
            
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url, modalVisible, addmodalVisible, reorderModalVisible]); // Product Fetch

    useEffect(() => { 
      
      const codeDetail = {
          GST_pcat_id: selectedProduct.pcat_id,
      };
      const fetchHSNcodeList = async () => { 
          try {
            const response = await fetch(`${host_url}/hsncode_select`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                codeDetail: codeDetail,
              }),
            });            
            const data = await response.json();
            setCodeList(data);              
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
       
       if(modalVisible || addmodalVisible ){
        fetchHSNcodeList(); 
       }
    }, [selectedProduct.pcat_id]); // HSN Code Fetch

    useEffect(() => {
      if (selectedProduct.prd_rate) {
        setUnitlist(prevUnitlist => 
          prevUnitlist.map(unit => ({
            ...unit,
            prange_rate: Math.ceil(unit.prange_qty * selectedProduct.prd_rate),  
          }))
        );
      }
    }, [selectedProduct.prd_rate]); // Recalculate prange_rate

    

    const filteredPrdlist = prdlist.filter(prd =>
      prd.prd_name.toLowerCase().includes(prdNameFilter.toLowerCase()) &&
      prd.prd_Ename.toLowerCase().includes(prdEnameFilter.toLowerCase()) && 
      String(prd.pcat_id).toLowerCase().includes(catEnameFilter.toLowerCase()) && 
      prd.prd_status.toLowerCase().includes(prdStatusFilter.toLowerCase()) &&
      (stockFilter === "" ||  (stockFilter === "Minus" && prd.prd_stock < 0) || (stockFilter === "Plus" && prd.prd_stock > 0))
    );

    const totalCount = filteredPrdlist.length;
   
    const handleProductDetail = (product) => {
      setModalVisible(true);
      setSelectedProduct(product);
    };

    // Functions for handling the different actions
    const handleAddProduct = async () => {
      setAddModalVisible(false);
      const formData = new FormData();
      formData.append('image', uploadImage);
      formData.append("type", "insert");
      formData.append("store", store);
      formData.append("prdlist", JSON.stringify(selectedProduct));
      formData.append("rangelist", JSON.stringify(unitlist));
      try {
        const response = await fetch(`${host_url}/product_mlist`, {
          method: 'POST',
          body: formData,
        });
        
        const data = await response.json();
        setPrdlist(data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }   
    };

    const handleUpdateProduct = async () => {
      setModalVisible(false);
      const formData = new FormData();
        if (uploadImage) {
          formData.append('image', uploadImage);
          formData.append("type", "update");
          formData.append("store", store);
          formData.append("prdlist", JSON.stringify(selectedProduct));
          formData.append("rangelist", JSON.stringify(unitlist));
        } else {
          formData.append("type", "update");
          formData.append("store", store);
          formData.append("prdlist", JSON.stringify(selectedProduct));
          formData.append("rangelist", JSON.stringify(unitlist));
        } 

      try {
        const response = await fetch(`${host_url}/product_mlist`, {
          method: 'POST',
          body: formData,
        });
        
        const data = await response.json();
        setPrdlist(data);
        setSelectedProduct('');
      } catch (error) {
        console.error('Error fetching categories:', error);
      }    
    };

    const handleDeleteCategory = async () => {
      setModalVisible(false);
      const userConfirmed = window.confirm('Are you sure you want to delete this Category?');
      if (userConfirmed) {
        const formData = new FormData();
        formData.append("type", "delete");
        formData.append("store", store);
        formData.append("prdlist", JSON.stringify(selectedProduct));
        
        try {
          const response = await fetch(`${host_url}/product_mlist`, {
            method: 'POST',
            body: formData,
          });
          
          const data = await response.json();
          setPrdlist(data);
        } catch (error) {
          console.error('Error fetching categories:', error);
        }   
      } 
    };

    const handleAddModal = async (e) => {
      setSelectedProduct('');
      setUnitlist([]);
      setAddModalVisible(true);
    };

    const handleImage = async (e) => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    };

    const handleFileChange = async (e) => {
      const file = e.target.files[0];
      
      if(file) {
        setUploadImage(e.target.files[0]);
        const previewUrl = URL.createObjectURL(file);
        setImagePreview(previewUrl);
      }
    };

    const handleAddRangeModal = async (e) => {
      setModalvalue('Add');  
      setSelectedUnit('');
      setRangeModalVisible(true);
    };

    const handleupdateRangeModal = async (unit) => {
      setModalvalue('Update');  
      setSelectedUnit(unit);
      setRangeModalVisible(true);
    };

    const handleAddRange = async () => {
      setRangeModalVisible(false);
      if(modalvalue === 'Add') {
          setUnitlist(prevUnitlist => [...prevUnitlist, selectedunit]);
      }  
      if(modalvalue === 'Update') {
          const updatedUnitList = unitlist.map(item => {
              if (item.prange_id === selectedunit.prange_id) {
                  return {
                      ...item, // Make a copy of the current item
                      prange_weight: '',
                      prange_qty: selectedunit.prange_qty, 
                      prange_unit: selectedunit.prange_unit,
                      prange_Eunit: selectedunit.prange_Eunit, 
                      prange_rate: selectedunit.prange_rate,
                  };
              }
              return item;
          });
          setUnitlist(updatedUnitList);
      }
    };

    const handleDeleteRange = async () => {
      setRangeModalVisible(false);
      const updatedUnitList = unitlist.filter(item => String(item.prange_rate) !== String(selectedunit.prange_rate));
      setUnitlist(updatedUnitList);
    };

    const handleRateChange = (e) => {
      const updatedRate = e.target.value;
      setSelectedProduct(prevState => ({
        ...prevState,
        prd_rate: updatedRate
      }));
    };

    const handleReorder = async (catId) => {
      
      setReorderModalVisible(true);
    };

    const moveToPriority = async (product) => {
      // backend update

      try {
        const response = await fetch(`${host_url}/product_reorder`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            store: store,
            prd_id : product.prd_id,
            prd_priority: 1,
          }),
        });
        const data = await response.json();
      
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
      
      setAllProducts(prev => prev.filter(p => p.prd_id !== product.prd_id));
      setPriorityProducts(prev => [...prev, { ...product, prd_priority: 1 }].sort((a, b) => a.prd_name.localeCompare(b.prd_name)));
    };

    const removeFromPriority = async (product) => {
      // backend update

      try {
        const response = await fetch(`${host_url}/product_reorder`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            store: store,
            prd_id : product.prd_id,
            prd_priority: 0,
          }),
        });
        const data = await response.json();
        console.log(data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }

      setPriorityProducts(prev => prev.filter(p => p.prd_id !== product.prd_id));
      setAllProducts(prev => [...prev, { ...product, prd_priority: 0 }].sort((a, b) => a.prd_name.localeCompare(b.prd_name)));
    };

    

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Product Master</b>
              <div onClick={handleAddModal}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div> 
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th rowSpan={2} >
                    {catEnameFilter !== "" && (
                      <Button color="primary" style={{ marginTop: '5px', marginBottom: '5px', width: '90%', paddingTop: '0px', paddingBottom: '0px', fontSize: '14px' }} onClick={() => handleReorder(catEnameFilter)}>Product Reorder</Button>
                    )}                     
                </th>
                <th colSpan='2'>G_Name</th>
                <th colSpan='2'>E_Name</th>
                <th colSpan='2'>Category</th>
                <th>Status</th>
                <th>Stock</th>
              </tr>
              <tr>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={prdNameFilter}
                    onChange={(e) => setPrdNameFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={prdEnameFilter}
                    onChange={(e) => setPrdEnameFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    value={catEnameFilter}
                    onChange={(e) => setCatEnameFilter(e.target.value)}
                  >
                    <option value="">All Category</option>
                    {catlist.map((catlist) => (
                      catlist.pcat_count > 0 && (
                        <option key={catlist.pcat_Id} value={catlist.pcat_id}>
                          {catlist.pcat_Ename}
                        </option>
                      )
                    ))}
                  </select>
                </th>
                <th>
                  <select
                    className="search-input"
                    value={prdStatusFilter}
                    onChange={(e) => setPrdStatusFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Y">Active</option>
                    <option value="N">Inactive</option>
                  </select>
                </th>
                <th>
                  <select
                    className="search-input"
                    value={stockFilter}
                    onChange={(e) => setStockFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Minus">Minus</option>
                    <option value="Plus">Plus</option>
                  </select>  
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredPrdlist.map((row) => {
                  return (
                    <tr key={row.prd_id} style={{ lineHeight: '10px' }} onClick={() => handleProductDetail(row)}>
                      <td style={{ padding: 0 }}><img src={row.prd_image_url || null} alt="Category" width="50" height="50"/></td>
                      <td className="cell-left" colSpan="2">
                        <div style={{ paddingLeft: '10px', lineHeight: '1.2' }}>
                          {row.prd_name}
                        </div>
                        <div style={{ paddingLeft: '10px', lineHeight: '1.2', color:'gray', fontSize: '13px' }}>
                          {row.prd_tag}
                        </div>
                      </td>
                      <td className="cell-left" colSpan="2">
                        <div style={{ paddingLeft: '10px', lineHeight: '1.2' }}>
                          {row.prd_Ename}
                        </div>
                        <div style={{ paddingLeft: '10px', lineHeight: '1.2', color:'gray', fontSize: '13px' }}>
                          {row.prd_Etag}
                        </div>
                      </td>
                      <td className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}>{row.pcat_Ename}</span></td>
                      <td>
                        <span style={{display: 'flex', paddingLeft: '10px'}}>
                          <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: row.prd_status === 'N' ? '#ff0000' : '#00962d', marginRight: '5px'}}></span>
                          <span>{row.prd_status === 'N' ? 'Inactive' : 'Active'}</span>
                        </span>
                      </td>
                      <td className="cell-right" style={{ color: row.prd_stock < 0 ? 'red' : 'inherit' }} >{row.prd_stock == 0 ? '' : row.prd_stock } </td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left"><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}>Total</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}></span></th>
              </tr>
            </tfoot>
          </table>
        
          {/* Modal for Product Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '32%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">નામ</td>
                          <td><input type="text" value={selectedProduct.prd_name} onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_name: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">ટેગ</td>
                          <td><input type="text" value={selectedProduct.prd_tag} onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_tag: e.target.value })} /></td>
                        </tr>
                          {unitlist && unitlist.length > 0 && unitlist.map((unit, index) => (
                            <tr key={index} style={{ cursor: 'pointer' }} onClick={() => handleupdateRangeModal(unit)}>
                              <td></td>
                              <td className="cell-left">{unit.prange_unit} == {unit.prange_rate} Rs</td>
                            </tr>
                          ))}
                        <tr>
                          <td colSpan='2'>
                            <textarea 
                              value={selectedProduct.prd_detail} 
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_detail: e.target.value })} 
                              rows="5" 
                            />
                          </td>
                        </tr>             
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '32%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Name</td>
                          <td><input type="text" value={selectedProduct.prd_Ename} onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_Ename: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">Tag</td>
                          <td><input type="text" value={selectedProduct.prd_Etag} onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_Etag: e.target.value })} /></td>
                        </tr>
                          {unitlist && unitlist.length > 0 && unitlist.map((unit, index) => (
                            <tr key={index} style={{ cursor: 'pointer' }} onClick={() => handleupdateRangeModal(unit)}>
                              <td></td>
                              <td  className="cell-left" >{unit.prange_Eunit} == {unit.prange_rate} Rs</td>
                            </tr>
                          ))}
                        <tr>
                          <td colSpan='2'>
                            <textarea 
                              value={selectedProduct.prd_Edetail} 
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_Edetail: e.target.value })} 
                              rows="5" 
                            />
                          </td>
                        </tr>             
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '32%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              {imagePreview || selectedProduct.prd_image_url ? (
                                <img 
                                  src={imagePreview ? imagePreview : selectedProduct.prd_image_url} 
                                  alt="Category" 
                                  style={{ width: '100px', height: '100px', objectFit: 'contain', cursor: 'pointer' }} 
                                  onClick={() => fileInputRef.current.click()} 
                                />
                              ) : (
                                <Button 
                                  color="info" 
                                  style={{ marginLeft: '10px', marginRight: '10px' }} 
                                  onClick={() => fileInputRef.current.click()}
                                >
                                  Upload Image
                                </Button>
                              )}
                              <input 
                                type="file" 
                                style={{ display: 'none' }} 
                                accept="image/*" 
                                ref={fileInputRef} 
                                onChange={handleFileChange} 
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className='cell-left'>Rate</td>
                          <td >
                            <input 
                              type="text" 
                              value={selectedProduct.prd_rate} 
                              onChange={handleRateChange} 
                              />
                          </td>
                        </tr>
                        <tr>
                          <td className='cell-left'>Weight Ration</td>
                          <td><input type="text" value={selectedProduct.prd_wr} onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_wr: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className='cell-left'>Category</td>
                          <td>
                              <select
                                value={selectedProduct.pcat_id}
                                onChange={(e) => setSelectedProduct({ ...selectedProduct, pcat_id: e.target.value })}
                              >
                                {catlist.map((catlist) => (
                                    <option key={catlist.pcat_Id} value={catlist.pcat_id}>
                                      {catlist.pcat_Ename}
                                    </option>
                                ))}
                              </select>
                          </td>                      
                        </tr>
                        <tr>
                          <td className='cell-left'>HSN Code</td>
                          <td><select
                                value={selectedProduct.prd_code_id}
                                onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_code_id: e.target.value })}
                              >
                                <option key='' value=''>Select HSNCode</option>
                                {codeList.map((codelist, index) => (
                                    <option key={index} value={codelist.GST_code_id}>
                                      {codelist.GST_hsn_code}
                                    </option>
                                ))}
                              </select>
                          </td>                      
                        </tr>
                        <tr>
                          <td className='cell-left'>Status</td>
                          <td><select
                                value={selectedProduct.prd_status}
                                onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_status: e.target.value })}
                              >
                                <option value="Y">Active</option>
                                <option value="N">Inactive</option>
                              </select>
                          </td>                      
                        </tr>
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>      
                              {selectedProduct.pcat_count < 1 && (
                                <Button color="danger" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleDeleteCategory} >
                                  Delete
                                </Button>
                              )}
                              {unitlist.length < 4 && (
                                <Button color="info" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleAddRangeModal} >
                                  Unit 
                                </Button>
                              )}  
                                <input type="file" style={{ display: 'none' }} accept="image/*" ref={fileInputRef} onChange={handleFileChange} /> 
                                <Button 
                                  color="success" 
                                  style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} 
                                  onClick={handleUpdateProduct}
                                  disabled= {!(
                                                unitlist.length > 0 && 
                                                selectedProduct.prd_rate && 
                                                selectedProduct.prd_wr && 
                                                selectedProduct.prd_status && 
                                                selectedProduct.prd_name && 
                                                selectedProduct.prd_Ename && 
                                                selectedProduct.prd_tag && 
                                                selectedProduct.prd_Etag && 
                                                selectedProduct.pcat_id && 
                                                selectedProduct.prd_code_id &&
                                                (imagePreview || selectedProduct.prd_image_url)
                                            )}
                                >
                                  Submit
                                </Button>
                                <Button color="primary" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={() => setModalVisible(false)}>
                                  Close
                                </Button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>

          {/* Modal for Add New Product */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '32%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">નામ</td>
                          <td><input type="text" value={selectedProduct.prd_name} onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_name: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">ટેગ</td>
                          <td><input type="text" value={selectedProduct.prd_tag} onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_tag: e.target.value })} /></td>
                        </tr>
                          {unitlist && unitlist.length > 0 && unitlist.map((unit, index) => (
                            <tr key={index} style={{ cursor: 'pointer' }} onClick={() => handleupdateRangeModal(unit)}>
                              <td></td>
                              <td className="cell-left">{unit.prange_unit} == {unit.prange_rate} Rs</td>
                            </tr>
                          ))}
                        <tr>
                          <td colSpan='2'>
                            <textarea 
                              value={selectedProduct.prd_detail} 
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_detail: e.target.value })} 
                              rows="5" 
                            />
                          </td>
                        </tr>             
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '32%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Name</td>
                          <td><input type="text" value={selectedProduct.prd_Ename} onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_Ename: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">Tag</td>
                          <td><input type="text" value={selectedProduct.prd_Etag} onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_Etag: e.target.value })} /></td>
                        </tr>
                          {unitlist && unitlist.length > 0 && unitlist.map((unit, index) => (
                            <tr key={index} style={{ cursor: 'pointer' }} onClick={() => handleupdateRangeModal(unit)}>
                              <td></td>
                              <td  className="cell-left" >{unit.prange_Eunit} == {unit.prange_rate} Rs</td>
                            </tr>
                          ))}
                        <tr>
                          <td colSpan='2'>
                            <textarea 
                              value={selectedProduct.prd_Edetail} 
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_Edetail: e.target.value })} 
                              rows="5" 
                            />
                          </td>
                        </tr>             
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '32%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              {imagePreview || selectedProduct.prd_image_url ? (
                                <img 
                                  src={imagePreview ? imagePreview : selectedProduct.prd_image_url} 
                                  alt="Category" 
                                  style={{ width: '120px', height: '120px', objectFit: 'contain', cursor: 'pointer' }} 
                                  onClick={() => fileInputRef.current.click()} 
                                />
                              ) : (
                                <Button 
                                  color="info" 
                                  style={{ marginLeft: '10px', marginRight: '10px' }} 
                                  onClick={() => fileInputRef.current.click()}
                                >
                                  Upload Image
                                </Button>
                              )}
                              <input 
                                type="file" 
                                style={{ display: 'none' }} 
                                accept="image/*" 
                                ref={fileInputRef} 
                                onChange={handleFileChange} 
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td >Rate</td>
                          <td >
                            <input 
                              type="text" 
                              value={selectedProduct.prd_rate} 
                              onChange={handleRateChange} 
                              />
                          </td>
                        </tr>
                        <tr>
                          <td>Weight Ration</td>
                          <td><input type="text" value={selectedProduct.prd_wr} onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_wr: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td>Category</td>
                          <td><select
                                value={selectedProduct.pcat_id}
                                onChange={(e) => setSelectedProduct({ ...selectedProduct, pcat_id: e.target.value })}
                              >
                                <option value=''>Select Category</option>
                                {catlist.map((catlist) => (
                                    <option key={catlist.pcat_Id} value={catlist.pcat_id}>
                                      {catlist.pcat_Ename}
                                    </option>
                                ))}
                              </select>
                          </td>                      
                        </tr>
                        <tr>
                          <td className='cell-left'>HSN Code</td>
                          <td><select
                                value={selectedProduct.prd_code_id}
                                onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_code_id: e.target.value })}
                              >
                                <option key='' value=''>Select HSNCode</option>
                                {codeList.map((codelist, index) => (
                                    <option key={index} value={codelist.GST_code_id}>
                                      {codelist.GST_hsn_code}
                                    </option>
                                ))}
                              </select>
                          </td>                      
                        </tr>
                        <tr>
                          <td>Status</td>
                          <td><select
                                value={selectedProduct.prd_status}
                                onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_status: e.target.value })}
                              >
                                <option value="">Select Status</option>
                                <option value="Y">Active</option>
                                <option value="N">Inactive</option>
                              </select>
                          </td>                      
                        </tr>
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>      
                              {(unitlist.length < 4 && selectedProduct.prd_rate) && (
                                <Button color="info" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleAddRangeModal} >
                                  Unit 
                                </Button>
                              )}  
                                <input type="file" style={{ display: 'none' }} accept="image/*" ref={fileInputRef} onChange={handleFileChange} /> 
                                <Button 
                                  color="success" 
                                  style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} 
                                  onClick={handleAddProduct}
                                  disabled= {!(
                                                unitlist.length > 0 && 
                                                selectedProduct.prd_rate && 
                                                selectedProduct.prd_wr && 
                                                selectedProduct.prd_status && 
                                                selectedProduct.prd_name && 
                                                selectedProduct.prd_Ename && 
                                                selectedProduct.prd_tag && 
                                                selectedProduct.prd_Etag && 
                                                selectedProduct.pcat_id && 
                                                selectedProduct.prd_detail && 
                                                selectedProduct.prd_Edetail && 
                                                (imagePreview || selectedProduct.prd_image_url)
                                            )}
                                >
                                  Submit
                                </Button>
                                <Button color="primary" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={() => setAddModalVisible(false)}>
                                  Close
                                </Button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>  

          {/* Modal for Unit Detail*/}
            <Modal isOpen={rangeModalVisible} toggle={() => setModalVisible(!rangeModalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Unit Detail</h5>  
                  <div>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Qty</td>
                          <td><input type="text" value={selectedunit.prange_qty} onChange={(e) => setSelectedUnit({...selectedunit, prange_qty: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">Rate</td>
                          <td><input type="text"  onChange={(e) => setSelectedUnit({ ...selectedunit, prange_rate: e.target.value })}  placeholder={Math.ceil(selectedunit.prange_qty * selectedProduct.prd_rate) || ''}/></td>
                        </tr>
                        <tr>
                          <td className="cell-left">E_Unit</td>
                          <td><input type="text" value={selectedunit.prange_Eunit} onChange={(e) => setSelectedUnit({...selectedunit, prange_Eunit: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">G_Unit</td>
                          <td><input type="text" value={selectedunit.prange_unit} onChange={(e) => setSelectedUnit({ ...selectedunit, prange_unit: e.target.value })} /></td>
                        </tr>
                        
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>      
                               
                                  <Button color="danger" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleDeleteRange}>
                                    Delete
                                  </Button>
                              
                                  <Button 
                                    color="success" 
                                    style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} 
                                    onClick={handleAddRange}
                                    disabled={!selectedunit.prange_qty || !selectedunit.prange_rate || !selectedunit.prange_Eunit || !selectedunit.prange_unit}
                                  >
                                    Submit
                                  </Button>
                                  <Button color="primary" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={() => setRangeModalVisible(false)}>
                                    Close
                                  </Button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </ModalBody>
            </Modal>  

          {/* Modal for Reorder Product*/}
            <Modal isOpen={reorderModalVisible} toggle={() => setModalVisible(!reorderModalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
                <div style={{ backgroundColor: '#e8fadb', margin: 0,  display: 'flex',}}>
                    <div style={{ width: '75%' }}> 
                      <h5 className="m-2 p-0">
                        {
                          catlist.find(cat => cat.pcat_id === Number(catEnameFilter))?.pcat_Ename || ""
                        }  {" "}Reorder
                      </h5>
                    </div>  
                    <div style={{ width: '25%'}}>
                      <Button className="m-2 p-0" color="primary" size="sm"  onClick={() => setReorderModalVisible(false)}>
                        Close
                      </Button>
                    </div>
                </div> 
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '48%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th  style={{ padding: '2px' }} >All Product</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {allProducts.map((row) => {
                            return (
                              <tr key={row.prd_id} style={{ cursor: 'pointer' }} onDoubleClick={() => moveToPriority(row)}>
                                <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                              </tr>
                            );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th  style={{ padding: '2px' }} >Priority</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {priorityProducts.map((row) => {
                            return (
                              <tr key={row.prd_id} style={{ cursor: 'pointer' }} onDoubleClick={() => removeFromPriority(row)}>
                                <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                              </tr>
                            );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>  

    </div>
  );
};

export default ProductMaster;
